<div>
    <h5 mat-dialog-title class="modal_title flex">
        {{ activePath?.includes('/email-accounts') || activePath?.includes('/onboarding') ? ("EMAIL_MARKETING.HOW_TO_CONNECT_GOOGLE_OAUTH_ACCOUNT" | translate) : activePath?.includes('/custom-tracking-domain') ? ('SETTING_PAGE.HOW_TO_ADD_CUSTOM_TRACKING_DOMAIN' | translate) : activePath?.includes('/hubspot') ? ('INTEGRATION_PAGE.HOW_TO_CONNECT_HUBSPOT' | translate) : ('INTEGRATION_PAGE.HOW_TO_CONNECT_PIPEDRIVE' | translate)}}
        <i class="ri-close-fill ml-auto text-[22px] leading-none cursor-pointer font-medium text-[#0b0d13]"
            mat-dialog-close></i>
    </h5>
    <mat-dialog-content class="modal_body">
        <div class="w-full h-[255px]">
            <div *ngIf="mapping?.isVideoLoad" class="flex items-center justify-center h-full">
                <i class="bx bx-loader bx-spin text-primary text-xl"></i>
            </div>
            <iframe style="width:100%;" frameborder="0" [src]="mapping?.videoSrc" height="260" (load)="onVideoLoad()"
                [class.hidden]="mapping?.isVideoLoad" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="form_action">
        <button matRipple class="cancel_btn" mat-dialog-close>{{ "GENERAL.CLOSE" | translate }}</button>
    </mat-dialog-actions>
</div>
